import classNames from "classnames";
import Loading from "../base/Loading";

function SubmitButton({isSubmitting, className, text, disabled}) {
    const buttonClassName = classNames('btn btn-primary btn--w-140', className)

    return (
       <button type="submit" className={buttonClassName} disabled={disabled}>
           {isSubmitting ? <Loading/> : text}
       </button>
    )
}

export default SubmitButton;
